/**
 * StoryTeaserSection — MADE-259
 *
 * Two-sentence brand teaser anchored on "1992".
 * "Our story →" links to /shop/about (retail-web About page).
 */

import { Box, Container, Typography } from '@mui/material';

export function StoryTeaserSection() {
  return (
    <Box
      component="section"
      aria-labelledby="story-teaser-label"
      sx={{
        backgroundColor: 'white',
        py: { xs: 8, md: 10 },
        borderTop: '1px solid rgba(0,0,0,0.06)',
      }}
    >
      <Container maxWidth="sm">
        <Box sx={{ textAlign: 'center' }}>
          <Typography
            id="story-teaser-label"
            variant="body1"
            component="p"
            sx={{
              color: '#444',
              fontSize: { xs: '1.1rem', md: '1.25rem' },
              lineHeight: 1.85,
              mb: 1,
            }}
          >
            Made.bb has been manufacturing in Barbados since 1992.
          </Typography>
          <Typography
            variant="body1"
            component="p"
            sx={{
              color: '#444',
              fontSize: { xs: '1.1rem', md: '1.25rem' },
              lineHeight: 1.85,
              mb: 4,
            }}
          >
            We combine decades of industrial expertise with modern additive manufacturing technology.
          </Typography>
          <Box
            component="a"
            href="/shop/about"
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              color: '#667eea',
              fontWeight: 600,
              fontSize: '1.05rem',
              textDecoration: 'none',
              borderBottom: '2px solid rgba(102,126,234,0.38)',
              pb: 0.25,
              transition: 'border-color 0.2s',
              '&:hover': { borderBottomColor: '#667eea' },
            }}
          >
            Our story →
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
